<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <path d="M8.28169 3.65085C8.84488 3.51903 9.42149 3.45313 9.9999 3.45449C15.7273 3.45449 19 10 19 10C18.5034 10.9292 17.9111 11.8039 17.2327 12.6101M11.7345 11.7346C11.5098 11.9758 11.2388 12.1692 10.9377 12.3034C10.6366 12.4375 10.3115 12.5097 9.98197 12.5155C9.65239 12.5213 9.32502 12.4607 9.01938 12.3372C8.71374 12.2138 8.4361 12.03 8.20302 11.7969C7.96993 11.5638 7.78618 11.2862 7.66273 10.9806C7.53928 10.6749 7.47865 10.3475 7.48447 10.018C7.49028 9.68839 7.56242 9.36336 7.69658 9.06227C7.83074 8.76118 8.02416 8.49019 8.26532 8.26547M14.86 14.8601C13.4613 15.9262 11.7583 16.5169 9.9999 16.5456C4.27253 16.5456 0.999756 10 0.999756 10C2.0175 8.10338 3.42909 6.44631 5.13982 5.13997L14.86 14.8601Z" stroke="#202830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M1 1L19 19" stroke="#202830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
    name: 'IconEyeOff',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
